// Perspectives Switcher shortcuts, starting at index 1
export const PerspectiveShortcut = (index: number) => `Shift+${index}`;

export const SAVE_VIEW_SHORTCUT = "Ctrl+S";
export const SAVE_AS_VIEW_SHORTCUT = "Ctrl+Shift+S";
export const RESET_VIEW_SHORTCUT = "Ctrl+Shift+R";

// View Menu Button shortcuts

// Component Finder
export const ComponentFinderShortcut = "Control+Shift+F";
